import BaseSearchSelect from 'components/atoms/base-search-select';
import { useGetCareManagers } from 'infrastructure/hooks/agency-doctor';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fullNamePresenter } from 'utils';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

const TransferTo: FC = () => {
  const { t } = useTranslation();
  const { filter, updateFilter, debouncedUpdateFilter } = useFilter();
  const managers = useGetCareManagers({
    fullName: filter.toName,
  });

  return (
    <div className={s['form-group']}>
      <label>{t('labels.transferTo')}</label>

      <BaseSearchSelect
        isLoading={managers.isLoading}
        options={managers.data?.rows?.map((m) => ({
          label: fullNamePresenter({
            firstName: m.firstName,
            lastName: m.lastName,
          }),
          value: m.guid,
        }))}
        placeholder={t('labels.select')}
        value={filter.toAgencyDoctorGuid}
        onChange={(searchValue) =>
          debouncedUpdateFilter({ toName: searchValue })
        }
        onSelect={(v) => {
          updateFilter({ toAgencyDoctorGuid: v });
        }}
        onClear={() => {
          updateFilter({
            toName: undefined,
            toAgencyDoctorGuid: undefined,
          });
        }}
      />
    </div>
  );
};

export default TransferTo;
